<template>
  <v-app>
    <terms/>
    <UserData/>
    <Confirmation/>
    <v-container fluid>
      <v-toolbar :clipped-left="true" class="wide" color="primary hidden-print-only" dark flat app fixed>
        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="font-weight-black white--text ml-0" id="title" @click="clickTitle">SIGNAL
            <span class="font-weight-thin white--text tight">FLOW
            </span>
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <MenuPop class="mr-3" @onLogout="onLogout"></MenuPop>
      </v-toolbar>
      <v-content  class="margin__hide align-center justify-center h-100 w-100" >
        <router-view></router-view>
      </v-content>
      <v-snackbar class="secondary--text" :timeout=5000 :color="message.color" :center="true" :top="true" v-model="message.visible">
        <v-icon color="secondary" class="mr-2">{{ message.icon }}</v-icon>
        {{ message.text }}
        <v-btn light flat @click.native="clearMessage">
          <v-icon color="secondary" right>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import MenuPop from "./components/common/MenuPop"
import Terms from "./components/common/Terms"
import UserData from "./components/common/UserData"
import Confirmation from "./components/common/ConfirmationModal";

export default {
  components: {
    MenuPop, Terms, UserData, Confirmation

  },
  data() {
    return {
      fixed: false
    }
  },
  computed: {
    ...mapGetters({
      message: "common/message"
    }),
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      )
    }
  },
  created(){
     this.$store.dispatch('autoSignIn')
  },
  methods: {
    ...mapActions({
      showMessage: "common/showMessage"
    }),
    clickTitle() {
      this.$router.push({ name: "ListProjects" })
    },
    clearMessage() {
      this.$store.dispatch("common/clearMessage")
    },
    onBack() {
      this.$router.go(-1)
    },
    onLogout() {
      this.$store.dispatch("logout")
      console.log("From App.vue")
      this.$router.push({ name: "Home" })
    }
  }
}
</script>

<style>
   @media only screen and (max-width: 600px) {
    .margin__hide{
      margin-top: -3em;
    }
    #title {
  cursor: pointer;
}
.tight {
  margin-left: -0.4vw;
}

.wide {
   box-sizing: unset;
  }
.w-100{
  width: 100%;
}
   }

   @media only screen and (min-width: 601px) {
    .margin__hide{
      margin-top: -3em;
    }
    #title {
  cursor: pointer;
}
.tight {
  margin-left: -0.4vw;
}

.wide {
   box-sizing: unset;
  }
.w-100{
  width: 100%;
}
   }
</style>




// WEBPACK FOOTER //
// src/App.vue